import { render, staticRenderFns } from "./copyDownload.vue?vue&type=template&id=548b4606&scoped=true&"
import script from "./copyDownload.vue?vue&type=script&lang=js&"
export * from "./copyDownload.vue?vue&type=script&lang=js&"
import style0 from "./copyDownload.vue?vue&type=style&index=0&id=548b4606&lang=less&scoped=true&"
import style1 from "./copyDownload.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548b4606",
  null
  
)

export default component.exports